import common from '@/store/common/mutations';
import * as types from './mutation-types';
import moment from 'moment';

let startMonth = moment().subtract(1, 'years').format('YYYY-MM');
let endMonth = moment().format('YYYY-MM');

//화면 진입시 초기화
const getInit = () => {
	return {
		searchParams: {
			carCd: null,
			selRowCarCd: null,
			startMonth: startMonth,
			endMonth: endMonth
		},
		grdSalesList: [], //그리드리스트
		carCdList: [], //검색에서 사용하는 차종
		gridCarList: [], //그리드 안에 차종(셀렉트박스인데 isDisabled처리)
		dayCols: [], //그리드 컬럼(년월컬럼)
		graphPieResultList: [], //그래프파이 임시저장소
		graphBarStackChartInfo: [], //그래프 스택 임시저장소
		searchPartPopParams: {
			//state에 넘길 파라미터 선언
			partNo: ''
		}
	};
};

export default {
	...common,
	[types.STATE_INIT]: state => {
		//초기화
		Object.assign(state, getInit());
	},
	[types.SEARCH_PARAM]: (state, { key, value }) => {
		state.searchParams[key] = value;
	},
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	},
	//파라미터 정의  ,actions 에도 정의
	[types.SEARCH_PART_POP_PARAMS]: (state, { key, value }) => {
		state.searchPartPopParams[key] = value;
	}
};
